module.exports = __webpack_public_path__ + "img/home-title-logo.21ccb4d7.png";